/**
 * Represents the total amount for a service, combining initial and additional quotation totals.
 */
export default class ServiceTotalAmount {
  /**
   * Constructs a new instance of the ServiceTotalAmount class.
   *
   * @param {number | string} initialQuotationTotal - The initial quotation total amount.
   * @param {number | string} additionalQuotationTotal - The additional quotation total amount.
   */
  constructor(initialQuotationTotal, additionalQuotationTotal) {
    this.value = parseFloat(initialQuotationTotal) + parseFloat(additionalQuotationTotal);
  }

  /**
   * Retrieves the value of the service total amount formatted as a string
   * with two decimal places.
   *
   * @returns {string} The formatted value as a string with two decimal places.
   */
  getValue() {
    return this.value.toFixed(2);
  }
}
